import { Injectable } from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { CalendarEvent } from "angular-calendar";
import { Reservation } from "src/app/models/reservation-model";
import { DateFormatterService } from "../date-formatter/date-formatter.service";
import { colors } from "src/app/utils/demo-utils/colors";

@Injectable({
  providedIn: "root",
})
export class ReservationService {
  entity: string = "/reservations";
  events$: Observable<CalendarEvent<{ reservation: Reservation }>[]>;

  constructor(private http: HttpClient, private authService: AuthService) { }


  fetchEvent(sartDate: any, endDate: any, studio: number): Observable<CalendarEvent[]> {
    const params = new HttpParams()
      .set('filters[start_date][$gte]', sartDate + " 00:00")
      .set('filters[end_date][$lte]', endDate + " 23:00")
      .set('filters[studio][id]', studio);

    return this.http
      .get(environment.api + this.entity, { params })
      .pipe(
        map((response: any) => {
          const results = response.data; // Access the 'data' array

          return results.map((item: any) => {

            const reservation: Reservation = item.attributes; // Access 'attributes'
            const start = (reservation.type == "ical") ? new Date(reservation.start_date) : DateFormatterService.toUTCDate(reservation.start_date);
            const end = (reservation.type == "ical") ? new Date(reservation.end_date) : DateFormatterService.toUTCDate(reservation.end_date);
            return {
              title: 'réservé',
              start: start, // Start date
              end: end,     // End date
              color: colors.red,                    // Set the color of the event
              meta: {
                reservation,                           // Optional metadata
              },
            } as CalendarEvent;
          });
        })
      );
  }

  get(filters?: string): Observable<any> {

    return this.http.get(
      environment.api + this.entity + ((filters) ? filters : ""),
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  create(data: any): Observable<any> {
    return this.http.post(
      environment.api + this.entity,
      data,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  busyIntervals(params: any): Observable<any> {
    return this.http.get(
      environment.api + this.entity + "/action/check-if-exist",
      { params }
    );
  }
}
